// Copyright ID Business Solutions Ltd. 2024
import styled from 'styled-components';

export const Dialog = styled.dialog`
  :host {
    --close-button-width: 1.875rem;
    --buttons-width: 6.25rem;
  }

  width: 500px;
  border: none;
  padding: 0;
  box-shadow: 0 0 0.625rem 0 var(--color-neutral-600);
  overflow: hidden;
  outline: none;

  &::backdrop {
    /** Can't use CSS custom properties here as ::backdrop doesn't inherit from :root where our properties are defined */
    background-color: rgb(67 74 84 / 80%);
  }
`;

export const Header = styled.header`
  grid-area: 1 / 1 / 2 / 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  background-color: var(--theme-main-800);
  color: var(--color-neutral-white);
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
  padding: 1rem;
`;

export const HeaderTitle = styled.div`
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const HeaderCloseButton = styled.button`
  font-size: 30px;
  line-height: 16px;
  cursor: pointer;
  user-select: none;
  border: none;
  background: none;
  color: var(--color-neutral-white) !important;

  &:hover {
    color: var(--color-neutral-300) !important;
  }

  &:focus-visible {
    /* disable the focus-ring, normally this is bad practice as it hinders keyboard users, in this case
       this UI element is only really of any use to mouse users, if a keyboard user wants to quickly dismiss
       the dialog they will almost certainly use the Escape key */
    outline: none;
  }
`;

export const Body = styled.div`
  grid-area: 2 / 1 / 3 / 2;
  display: flex;
  flex-direction: column;
  padding: 1rem 1rem 1rem 1.3rem;
  margin-bottom: 2rem;
  gap: 1.3rem;

  font-style: normal;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.25px;
`;

export const DescriptionText = styled.span`
  padding-top: 1rem;
  padding-bottom: 1rem;
`;

export const InputContainer = styled.div`
  gap: 2rem;
  display: flex;
  flex-direction: column;

  .idbs-react-label-content,
  .idbs-react-text-input-container {
    width: 26rem;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const ApiKeyContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: flex-end;
`;

export const Footer = styled.footer`
  grid-area: 3 / 1 / 4 / 2;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  color: var(--color-neutral-600);
  font-style: normal;
  font-weight: 400
  background-color: var(--color-neutral-50);
  padding: 1rem;
  gap: 0.5rem;
`;
